import { Report199Container } from "../../../containers/borrowSystem/Report/Report199Container";

export function Report199Page() {
    return (
        <Report199Container />
    )
}